/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const LeafIcon = ({ width, height }) => {
  return (
    <svg
      version="1.1"
      x="0"
      y="0"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      height={`${height || '100%'}`}
      width={`${width || '100%'}`}
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
        enable-background: new 0 0 512 512;
      `}
    >
      <g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m257.368 363.018c.869 28.26 5.061 48.689 5.061 48.689l217.371-217.371s-97.389-19.984-161.036 18.272"
                    fill="#95bd51"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="m262.428 411.708s122.445 25.125 182.471-34.901c60.025-60.026 34.9-182.471 34.9-182.471z"
                    fill="#95bd51"
                  />
                </g>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <path
                    d="m172.136 437.606s145.148-95.723 145.148-213.803-145.148-213.803-145.148-213.803"
                    fill="#95bd51"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="m172.136 10s-145.148 95.723-145.148 213.803 145.148 213.803 145.148 213.803"
                    fill="#95bd51"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <path
              d="m489.594 192.321c-.001-.003-.005-.029-.014-.075-.732-3.932-3.832-7.003-7.769-7.705-.001 0-.002 0-.002 0-3.899-.8-91.208-18.169-156.684 13.3-3.355-20.381-10.611-41.127-21.692-61.956-12.454-23.41-29.757-46.997-51.429-70.104-35.709-38.074-70.943-61.854-74.172-64.002-.411-.285-2.872-1.779-5.813-1.779-2.421 0-5.162 1.49-5.572 1.774-3.183 2.116-38.442 25.904-74.179 64.007-21.672 23.107-38.976 46.694-51.429 70.104-15.826 29.749-23.851 59.33-23.851 87.918 0 28.589 8.024 58.169 23.851 87.919 12.454 23.41 29.757 46.996 51.429 70.104 29.605 31.566 58.883 53.306 69.868 61.041v57.133c0 .339.017.674.05 1.004-.287 2.88.673 5.861 2.879 8.068 1.953 1.953 4.512 2.929 7.071 2.929s5.119-.976 7.071-2.929l86.592-86.592c9.381 1.566 30.079 4.447 55.329 4.447 3.373 0 6.828-.051 10.346-.164 52.456-1.682 94.123-16.511 120.496-42.883 26.373-26.373 41.201-68.04 42.883-120.496 1.246-38.846-5.259-71.062-5.259-71.063zm-162.378 26.948c42.889-23.88 101.588-21.32 131.449-17.941l-104.07 104.07v-29.156c0-5.523-4.478-10-10-10-5.523 0-10 4.477-10 10v49.156l-65.207 65.207c-.828-7.236-1.608-16.173-1.968-26.176 14.598-17.484 26.67-35.145 36.013-52.707 15.826-29.75 23.851-59.33 23.851-87.919 0-1.508-.023-3.02-.068-4.534zm-155.08-44.028c-5.523 0-10 4.477-10 10v76.689l-42.285-42.286c-3.905-3.905-10.237-3.905-14.142 0s-3.906 10.237-.001 14.143l56.428 56.428v37.978l-32.145-32.146c-3.905-3.904-10.237-3.904-14.143 0-3.905 3.905-3.905 10.237 0 14.143l46.288 46.288v61.493c-36.578-28.097-125.148-105.316-125.148-194.168 0-57.599 37.836-110.117 69.577-144.031 20.823-22.249 41.848-39.647 55.57-50.162v65.218c0 5.523 4.477 10 10 10s10-4.477 10-10v-65.193c36.578 28.096 125.148 105.316 125.148 194.168 0 57.599-37.837 110.116-69.577 144.03-20.823 22.249-41.848 39.647-55.571 50.162v-61.518l46.288-46.288c3.905-3.905 3.905-10.237 0-14.143-3.905-3.904-10.237-3.904-14.143 0l-32.146 32.146v-37.978l56.428-56.428c3.905-3.905 3.905-10.237 0-14.143-3.905-3.905-10.237-3.905-14.143 0l-42.286 42.286v-76.689c.003-5.522-4.474-9.999-9.997-9.999zm10 302.616v-34.991c10.579-7.448 38.126-27.889 66.591-57.585.938 10.143 2.115 18.149 2.931 23.053zm255.692-108.121c-41.852 41.854-118.605 39-154.26 34.975l64.717-64.717h54.566c5.522 0 10-4.477 10-10s-4.478-10-10-10h-34.566l104.519-104.519c4.024 35.656 6.878 112.407-34.976 154.261z"
              fill="#d9edb7"
            />
            <path
              d="m181.372 136.39c-1.66-3.982-5.822-6.524-10.127-6.135-4.145.375-7.676 3.366-8.763 7.376-1.073 3.96.476 8.336 3.828 10.714 3.421 2.427 8.049 2.462 11.507.092 3.848-2.635 5.315-7.75 3.555-12.047z"
              fill="#d9edb7"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default LeafIcon;

LeafIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
